import { createSlice } from "@reduxjs/toolkit";
import {
  getExtraQuizThunk,
  getExtraTopicThunk,
  updateExtraQuizThunk,
  createExtraQuizThunk,
  deleteExtraQuizThunk,
} from "./ExtraQuiz.Thunk";

const initialState = {
  data: [],
  topic: [],
  loading: false,
  status: "",
  message: "",
  language: "",
  usertype: "",
  type: "",
  topicId: "",
  topicName: "",
  disable_content_button: true,
};

const ExtraQuizSlice = createSlice({
  name: "extraquizslice",
  initialState,
  reducers: {
    language_change: (state, action) => {
      state.language = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    topic_change: (state, action) => {
      console.log(action,
        'on topic change');
      state.topicId = action.payload.topicId;
      state.topicName = action.payload.topicName;
      state.data = [];
      state.disable_content_button = false;
    },
  },
  extraReducers: {
    [getExtraQuizThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getExtraQuizThunk.fulfilled]: (state, action) => {
      console.log(action,"action ddj");
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getExtraQuizThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [getExtraTopicThunk.pending]: (state, action) => {
      state.topic = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getExtraTopicThunk.fulfilled]: (state, action) => {
      state.topic = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getExtraTopicThunk.rejected]: (state, action) => {
      state.topic = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createExtraQuizThunk.pending]: (state, action) => {
      // state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createExtraQuizThunk.fulfilled]: (state, action) => {
      // state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createExtraQuizThunk.rejected]: (state, action) => {
      // state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;  
    },

    [updateExtraQuizThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateExtraQuizThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateExtraQuizThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const {
  language_change,
  usertype_change,
  topic_change,
} = ExtraQuizSlice.actions;

export default ExtraQuizSlice.reducer;
